import api from './api';

export async function suggestContent(jobTitle, description) {
	const res = await api.post('/ai/suggest-content', { jobTitle, currentDescription: description });
	return res.data;
}

export async function analyzeResume(resumeId) {
	const res = await api.post(`/ai/analyze/${resumeId}`);
	return res.data;
}

export async function analyzeUploadedResume(file) {
	const form = new FormData();
	form.append('resume', file);
	const res = await api.post('/ai/analyze-upload', form, {
		headers: { 'Content-Type': 'multipart/form-data' }
	});
	return res.data;
}

export async function matchJob(resumeId, jobDescription) {
	const res = await api.post('/ai/match-job', { resumeId, jobDescription });
	return res.data;
}

export async function generateCoverLetter(resumeId, jobDescription, companyName) {
	const res = await api.post('/ai/generate-cover-letter', { resumeId, jobDescription, companyName });
	return res.data;
}

export async function getAnalysisHistory(page = 1, limit = 10) {
	const res = await api.get('/ai/analysis-history', { params: { page, limit } });
	return res.data;
}


